var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.886 17.4365L16.7679 11.8265H11.2556V8.18594C11.2556 6.65144 12.0254 5.15472 14.4943 5.15472H17V0.378781C17 0.378781 14.7265 0 12.5521 0C8.01295 0 5.04604 2.68731 5.04604 7.55141V11.8275H0V17.4375H5.04604V31H11.2556V17.4375L15.886 17.4365Z","fill":"#F5F3EC"}));
}

Facebook.defaultProps = {"width":"17","height":"31","viewBox":"0 0 17 31","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
